import React from 'react';
import { useState, useEffect } from 'react';
import axiosConfig from '#utils/axiosConfig';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrashAlt, FaCheckCircle } from 'react-icons/fa';
import { useAlert } from 'react-alert';
import Modal from '#components/Modal';
import { getVerifiedToken } from '#utils/authService';

const ListNumerosParte = () => {
	const [totalRows, setTotalRows] = useState();
	const [partNumbersPerPage, setPartNumberssPerPage] = useState(20);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageNumbers, setPageNumbers] = useState([]);
	const [client, setClient] = useState(0);
	const [search, setSearch] = useState('');
	const titles = [
		'# Parte',
		'Cliente',
		'U.M',
		'Peso U',
		'Descripcion Ing',
		'Descripcion Esp',
		'Pais',
		'Fraccion',
		'Marca',
		'Modelo',
		'Serie',
		'Habilitado/Deshabilitado',
		'Opciones'
	];
	const [partNumbers, setPartNumbers] = useState([]);
	const [clients, setClients] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [currentPartNumber, setCurrentPartNumber] = useState({});
	const alert = useAlert();
	const [userInfo, setUserInfo] = useState();

	useEffect(() => {
		const getUserInfo = async () => {
			const { decoded } = await getVerifiedToken();
			setUserInfo(decoded.usuario);
		};
		getUserInfo();
		getClients();
	}, []);
	useEffect(() => {
		getPartNumbers();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search, currentPage, partNumbersPerPage, client]);

	useEffect(() => {
		setCurrentPage(1);
	}, [partNumbersPerPage, search]);

	useEffect(() => {
		const auxPageNumbers = [];
		for (let i = 1; i <= Math.ceil(totalRows / partNumbersPerPage); i++) {
			auxPageNumbers.push(i);
		}
		setPageNumbers(auxPageNumbers);
	}, [totalRows, partNumbersPerPage]);

	const getClients = async () => {
		let { result: data } = await axiosConfig({
			method: 'get',
			url: '/data-system/clientes',
			params: {
				paginaActual: 1,
				limit: 100,
				deshabilitados: true
			}
		});
		setClients(data);
	};
	const getPartNumbers = async () => {
		let { partes, FilasTotales } = await axiosConfig({
			method: 'get',
			url: '/data-system/partes',
			params: {
				limit: partNumbersPerPage,
				paginaActual: currentPage,
				search,
				idCliente: client,
				deshabilitados: true
			}
		});
		if (FilasTotales > 0) {
			setTotalRows(FilasTotales);
		} else {
			setTotalRows(1);
		}
		setPartNumbers(partes);
	};

	const disablePartNumber = async () => {
		try {
			const { data } = await axiosConfig({
				method: 'put',
				url: '/Data-System/Partes/Habilitar',
				data: {
					idParte: currentPartNumber.Id_Parte
				}
			});

			if (data === 'OK') {
				alert.show(`El # Parte ${currentPartNumber.Numero_Parte} fue eliminado correctamente.`, {
					type: 'success'
				});
				getPartNumbers();
			}
		} catch (error) {
			alert.show('Hubo un problema al eliminar el numero de parte, intentelo mas tarde.', {
				type: 'error'
			});
		}
		setShowModal(false);
	};

	function renderModal() {
		if (showModal) {
			if (userInfo.Id_Tipo_Usuario === 3) {
				return (
					<Modal>
						<p className="text-xl text-black">
							­¿Desea {currentPartNumber.Disabled === 1 ? 'Habilitar' : 'Deshabilitar'} Este Numero
							de Parte?:
						</p>
						<p className="text-xl text-black">{currentPartNumber.Numero_Parte}</p>
						<div className="flex flex-row mt-2">
							<button
								className="mr-3 bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded-md"
								onClick={() => setShowModal(false)}
							>
								Cancelar
							</button>

							<button
								className="bg-green-500 hover:bg-green-700 text-white py-2 px-4 rounded-md"
								onClick={() => disablePartNumber()}
							>
								Confirmar
							</button>
						</div>
					</Modal>
				);
			} else {
				setShowModal(false);
				alert.show('Solo los administradores pueden habilitar/deshabilitar numeros de parte.', {
					type: 'error'
				});
			}
		}
	}

	return (
		<div className="mt-4 flex flex-col m-h-full h-full w-full">
			<div className="flex flex-col xl:flex-row items-center px-3 bg-gray-100 shadow-md mt-2">
				<div className="flex flex-col md:flex-row items-center">
					<p className="text-xl mt-2">Numeros de Parte</p>
					<input
						className="ml-2 bg-gray-200 appearance-none border-2 border-gray-200 rounded w-64 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
						id="search"
						type="text"
						value={search}
						onChange={event => setSearch(event.target.value)}
						placeholder="Buscar # Parte"
					/>
					<p className="text-xl mt-2 pl-2">Cliente</p>
					<select
						className="mt-1 md:mt-0 ml-2 bg-gray-200 appearance-none border border-gray-200 rounded w-64 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
						id="cliente"
						onChange={event => setClient(event.target.value)}
					>
						<option value="0">Todos</option>
						{clients.map(obj => {
							return (
								<option key={obj.Id_Cliente} value={obj.Id_Cliente}>
									{obj.Nombre_Cliente}
								</option>
							);
						})}
					</select>
				</div>
				<div className="flex flex-col md:flex-row">
					<div className="flex flex-row">
						<div className="ml-4 flex flex-row py-1">
							<button
								className={'text-xl ' + (currentPage === 1 ? 'opacity-50' : '')}
								onClick={() => {
									setCurrentPage(currentPage - 1);
								}}
								disabled={currentPage === 1 ? 'disabled' : ''}
							>
								&laquo;
							</button>
							<select
								value={currentPage}
								name="currentPage"
								id="currentPage"
								onChange={event => setCurrentPage(parseInt(event.target.value))}
								className="appearance-none w-20 bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
							>
								{pageNumbers.map(p => {
									return (
										<option key={p} value={p}>
											{p}
										</option>
									);
								})}
							</select>
							<button
								className={'text-xl ' + (currentPage === pageNumbers.length ? 'opacity-50' : '')}
								onClick={() => {
									setCurrentPage(currentPage + 1);
								}}
								disabled={currentPage === pageNumbers.length ? 'disabled' : ''}
							>
								&raquo;
							</button>
						</div>
						<label className="ml-2 mt-2 text-gray-700 text-xs font-bold mb-2">
							Mostrar
							<select
								value={partNumbersPerPage}
								onChange={event => setPartNumberssPerPage(parseInt(event.target.value))}
								className="ml-2 appearance-none w-20 bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
							>
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="100">100</option>
								<option value="200">200</option>
							</select>
						</label>
					</div>
					<Link
						className="mt-1"
						to="/Data-System/Catalogos/NumerosParte/Nuevo"
						style={{ textDecoration: 'none' }}
					>
						<button className="button btn-lg bg-green-600 ml-3">Agregar Numero de Parte</button>
					</Link>
				</div>
			</div>

			<div className="flex bg-gray-100 shadow-md mt-3 overflow-y-auto">
				{partNumbers.length === 0 ? (
					<h4>Sin Resultados</h4>
				) : (
					<table className="text-left w-full border-collapse table">
						<thead>
							<tr>
								{titles.map(title => (
									<th className="text-gray-dark" key={title}>
										{title}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{partNumbers.map(partNumber => {
								return (
									<tr key={partNumber.Id_Parte}>
										<td>{partNumber.Numero_Parte}</td>
										<td>{partNumber.numero_parte_cliente.Nombre_Cliente}</td>
										<td>{partNumber.unidad_numero_parte.Unidad_Medida}</td>
										<td>{partNumber.Peso_Unidad}</td>
										<td>{partNumber.Descripcion_Ing}</td>
										<td>{partNumber.Descripcion_Esp}</td>
										<td>{`${partNumber.pais_numero_parte.Nombre_Esp}-${partNumber.pais_numero_parte.Alfa3}`}</td>
										<td>{partNumber.Fraccion}</td>
										<td>{partNumber.Marca}</td>
										<td>{partNumber.Modelo}</td>
										<td>{partNumber.Serie}</td>
										<td>{+partNumber.Disabled === 0 ? 'Habilitado' : 'Deshabilitado'}</td>
										<td>
											<div className="flex flex-col lg:flex-row">
												<Link
													to={{
														pathname: '/Data-System/Catalogos/NumerosParte/Editar',
														state: { partNumberId: partNumber.Id_Parte }
													}}
												>
													<button className="button bg-blue-700 w-8 h-8">
														<FaEdit />
													</button>
												</Link>

												<button
													className={`mt-1 lg:mt-0 lg:ml-1 w-8 h-8 button ${
														+partNumber.Disabled === 1 ? 'bg-green-700' : 'bg-red-700'
													}`}
													onClick={() => {
														setCurrentPartNumber(partNumber);
														setShowModal(true);
													}}
												>
													{+partNumber.Disabled === 1 ? <FaCheckCircle /> : <FaTrashAlt />}
												</button>
											</div>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				)}
			</div>
			{renderModal()}
		</div>
	);
};

export default ListNumerosParte;
